import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import I18NextLoader from '../I18NextLoader';
const ReduxLoader = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "dreamup_form" */ '../ReduxLoader')));
const IngressPromptFormLoader = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "dreamup_form" */ '../IngressPromptForm')));
const LoadableIngressForm = (_param)=>{
    var { fallback } = _param, rest = _object_without_properties(_param, [
        "fallback"
    ]);
    const isMounted = useIsMounted();
    if (!isMounted) {
        return null; // never SSR
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "EditorLoadableWrapper"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: fallback !== null && fallback !== void 0 ? fallback : /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'llama',
            coverMode: true
        })
    }, /*#__PURE__*/ React.createElement(I18NextLoader, null), /*#__PURE__*/ React.createElement(ReduxLoader, null), /*#__PURE__*/ React.createElement(IngressPromptFormLoader, rest)));
};
LoadableIngressForm.displayName = 'LoadableIngressForm';
export default LoadableIngressForm;

//# sourceMappingURL=LoadableIngressForm.js.map